module.exports = __webpack_public_path__ + "static/media/navy-blue-logo.1a1b8e22.png";